import React, { useEffect, useState } from "react";
import { useLoaderData, useParams } from "react-router-dom";
import UnionInfoCard from "./UnionInfoCard";
import "../styles/main.css";
import PaymentCard from "./paymentCard";
import ErrorComponent from "./error";
import { Col, Row } from "antd";
import { CbdtApiService } from "../../cbdtService";
import SuccessComponent from "./success";
import FailureComponent from "./failure";
import PendingComponent from "./pending";
import { NotFound } from "../../../common";

const UnionPage = (props) => {
  const data = useLoaderData();
  const [is_valid, setValid] = useState(null);
  const [transaction_data, setTransactionData] = useState({});
  let { transaction_id } = useParams();
  console.log("transaction_id ", transaction_id, data);

  useEffect(() => {
    setTransactionData(data?.data);
    setValid(data?.data?.valid);
  }, []);
  if (
    (transaction_id === "success" ||
      transaction_id === "failure" ||
      transaction_id === "pending") &&
    data?.success
  ) {
    return (
      <>
        <div className="topbarstyle">
          <img
            className="union-bank-logo-mobile-view"
            src="https://ebz-static.s3.ap-south-1.amazonaws.com/layer/union_bank_logo_topbar.svg"
          ></img>
        </div>

        <div className="pageStyle">
          <div className="container-card">
            {transaction_id === "success" ? (
              <div className="centered-container">
                <SuccessComponent transaction_data={transaction_data} />
                <br></br>
                <div className="poweredbyEasebuzz">
                  <img
                    src="https://ebz-static.s3.ap-south-1.amazonaws.com/layer/easebuzz_logo.svg"
                    alt="Powered by Easebuzz"
                  />
                </div>
              </div>
            ) : transaction_id === "failure" ? (
              <>
                <div className="centered-container">
                  <FailureComponent transaction_data={transaction_data} />
                  <br></br>
                  <div className="poweredbyEasebuzz">
                    <img
                      src="https://ebz-static.s3.ap-south-1.amazonaws.com/layer/easebuzz_logo.svg"
                      alt="Powered by Easebuzz"
                    />
                  </div>
                </div>
              </>
            ) : (
              <div className="centered-container">
                <PendingComponent transaction_data={transaction_data} />
                <br></br>
                <div className="poweredbyEasebuzz">
                  <img
                    src="https://ebz-static.s3.ap-south-1.amazonaws.com/layer/easebuzz_logo.svg"
                    alt="Powered by Easebuzz"
                  />
                </div>
              </div>
            )}
          </div>
          <div className="copyright copyright-space">
            <p>Copyright © 2024 Union Bank of India. All rights reserved</p>
          </div>
        </div>
      </>
    );
  } else {
    return (
      <>
        <div className="topbarstyle">
          <img
            className="union-bank-logo-mobile-view"
            src="https://ebz-static.s3.ap-south-1.amazonaws.com/layer/union_bank_logo_topbar.svg"
          ></img>
        </div>

        <div className="pageStyle-payment">
          <div className="container-card">
            {is_valid === true ? (
              <Row
                className="bank-num-details"
                gutter={{ xs: 16, sm: 24, md: 32, lg: 48 }}
              >
                <Col
                  className="card-col-mobile"
                  xs={24}
                  sm={24}
                  md={24}
                  lg={14}
                  xl={13}
                >
                  <UnionInfoCard
                    className="common-style"
                    transaction_data={transaction_data}
                  />
                </Col>
                <Col
                  className="card-col-mobile"
                  xs={24}
                  sm={24}
                  md={24}
                  lg={10}
                  xl={11}
                >
                  <PaymentCard
                    transaction_data={transaction_data}
                    className="common-style"
                  />
                  <div className="poweredbyEasebuzz">
                    <img
                      src="https://ebz-static.s3.ap-south-1.amazonaws.com/layer/easebuzz_logo.svg"
                      alt="Powered by Easebuzz"
                    />
                  </div>
                </Col>
              </Row>
            ) : is_valid === false ? (
              <>
                <div className="centered-container">
                  <ErrorComponent transaction_data={transaction_data} />
                  <br></br>
                  <div className="poweredbyEasebuzz">
                    <img
                      src="https://ebz-static.s3.ap-south-1.amazonaws.com/layer/easebuzz_logo.svg"
                      alt="Powered by Easebuzz"
                    />
                  </div>
                </div>
              </>
            ) : (
              <div></div>
            )}
          </div>
          <div className="copyright copyright-space">
            <p>Copyright © 2024 Union Bank of India. All rights reserved</p>
          </div>
        </div>
      </>
    );
  }
};
export default UnionPage;

export const getTransactionData = async ({ params }) => {
  const queryString = window.location.pathname;
  let response = {
    success: false,
    data: null,
  };
  if (queryString) {
    response = await CbdtApiService.getUnionCustomerDetails({
      txnid: params.transaction_id,
    });
  }
  return response;
};

export const getTransactionStatusUnion = async ({ params }) => {
  const queryString = window.location.pathname;
  let response = {
    success: false,
    data: null,
  };
  if (queryString) {
    response = await CbdtApiService.getUnionCustomerDetails_form({
      txnid: params.txn,
    });
  }
  return response;
};
